import { createApp } from 'vue';
import PafToMp3Converter from '@/Components/PafToMp3Converter.vue';
import '@styles/app.css';

createApp(PafToMp3Converter).mount('#paf-to-mp3-converter');
